/**
 * this module is used to overwrite all project dependent client config options handled by frontend-controller/lib/appConfig.js
 */
module.exports = {
	useFecClient: true,
	store: {
		name: 'Cookie-Store',
	},
	// TODO: CLEANUP
	language: {
		available: {
			'de-at': {
				route: '/de', // which route to use when a client browses to '/' and its favourite language is de-at.
				icon: 'flag-icon flag-icon-at', // used for cms-flag-icons
			},
		}
	},
	ninjaModules: {
		events: {
			turnedOn: true,
		},
	},
};